import React from 'react';
import { forwardRef } from '@chakra-ui/system';
import { motion, isValidMotionProp } from 'framer-motion';
import { Box } from '@chakra-ui/layout';

const MotionBox = motion.custom(
  forwardRef((props, ref) => {
    const chakraProps = Object.fromEntries(
      // do not pass framer props to DOM element
      Object.entries(props).filter(([key]) => !isValidMotionProp(key))
    );
    return <Box ref={ref} {...chakraProps} />;
  })
);

const MotionImage = {
  $: 'Box',
  props: {
    overflow: 'hidden',
    position: 'relative',
  },
  imgContainerProps: {},
  imgProps: {},
  children: ({ content, src, backgroundImage, imgContainerProps, imgProps }) => {
    return {
      component: MotionBox,
      props: {
        whileHover: { scale: 1.1 },
        w: '100%',
        ...imgContainerProps,
      },
      children: [
        backgroundImage ? (
          {
            $: 'Box',
            props: {
              bgImage: `url("${src}")`,
              bgSize: 'cover',
              bgPosition: 'center',
              bgRepeat: 'no-repeat',
              w: '100%',
              h: '100%',
              _after: {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                w: '100%',
                h: '100%',
                bg: 'rgba(0, 0, 0, 0.2)',
                pointerEvents: 'none',
              },
              ...imgProps,
            },
            children: { ...content },
          }
        ) : (
          {
            $: 'Image',
            props: {
              src,
              ...imgProps,
            }
          }
        )
      ],
    };
  },
};

export default MotionImage;
